import type { BaseVacancyNotation } from '@pigello/pigello-matrix';
import { DateTime } from 'luxon';

export const getVacancyNotationStatus = (
  notation: BaseVacancyNotation
): {
  label: string;
  variant:
    | 'default'
    | 'gray'
    | 'light-gray'
    | 'green'
    | 'yellow'
    | 'blue'
    | 'purple'
    | 'orange'
    | 'cyan'
    | 'destructive'
    | 'outline';
} => {
  if (notation.annulled) return { label: 'Makulerad', variant: 'destructive' };

  const start = notation.startDate
    ? DateTime.fromISO(notation.startDate)
    : null;
  const end = notation.endDate ? DateTime.fromISO(notation.endDate) : null;
  const now = DateTime.now();
  if (!start) return { label: 'Okänt', variant: 'gray' };

  if (start > now) return { label: 'Kommande', variant: 'blue' };

  if (end && end < now) return { label: 'Tidigare', variant: 'gray' };

  return { label: 'Aktiv', variant: 'green' };
};
